// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplicationListView_root_2WZzC","inner":"ApplicationListView_inner_2j3BZ"};